import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isEqual from 'lodash/isEqual';
import FaClose from 'react-icons/lib/fa/close';
import Player from '../Player';
import Thumbnail from '../Thumbnail';


class VideoListLayout extends Component {
  constructor (props) {
    super(props);
    this.state = { active: null, height: null, shouldAutoplay: false };
    this.handleVideoClick = this.handleVideoClick.bind(this);
    this.handleVideoEnd = this.handleVideoEnd.bind(this);
    this.renderVideoThumb = this.renderVideoThumb.bind(this);
  }

  componentDidMount () {
    // Default set first video as the active item
    const { videos } = this.props;
    this.setState({
      active: videos[0],
      activeIndex: 0,
    });
  }

  componentDidUpdate (prevProps, prevState) {
    const { videos, onChange } = this.props;
    const { active } = this.state;
    if (!isEqual(this.state.active, prevState.active)) {
      requestAnimationFrame(() => {
        const height = this.activeVidContainer.clientHeight;
        this.setState({ height });
      });
      onChange();
    }

    if (!isEqual(active, prevState.active)) {
      this.setState({ activeIndex: videos.findIndex(v => v.slug === active.slug) });
    }
  }

  handleVideoClick (e, videoObj) {
    e.preventDefault();
    this.setState({
      active: videoObj,
      shouldAutoplay: true,
    });
  }

  handleVideoEnd () {
    const { videos } = this.props;
    const { activeIndex } = this.state;

    if (activeIndex + 1 < videos.length) {
      this.setState({
        active: videos[activeIndex + 1],
        shouldAutoplay: true,
      });
    }
  }

  renderVideoThumb (videoObj) {
    return (
      <div className="mb-2">
        <a href={`#${videoObj.vimeoId}`} onClick={e => this.handleVideoClick(e, videoObj)}>
          <Thumbnail image={videoObj.thumbnail} vimeoUrl={videoObj.vimeoUrl} />
        </a>
      </div>
    );
  }

  renderVideoList () {
    const { videos } = this.props;
    let xlColWidth = 3;
    if (videos.length === 3) {
      xlColWidth = 4;
    } else if (videos.length === 2) {
      xlColWidth = 6;
    }
    return videos.map((item, i) => (
      <div key={i + 1} className={`col-sm-6 col-xl-${xlColWidth} mt-3`}>
        {this.renderVideoThumb(item)}
        <h6 className="heading-display mb-1"><a href={`#${item.vimeoId}`} onClick={e => this.handleVideoClick(e, item)}>{item.title}</a></h6>
        <div className="caption" dangerouslySetInnerHTML={{ __html: item.body }} />
      </div>
    ));
  }

  renderActiveVideo () {
    const { breakpoint, videos } = this.props;
    const { active, height, shouldAutoplay } = this.state;
    // TODO: UI for scrolling right column

    // Avoid multiple scrollbars if modal container is not tall enough to fit main column
    let listColScrollable = true;
    if (this.activeVidContainer && this.containerRef) {
      const { top: vt, height: vh } = this.activeVidContainer.getBoundingClientRect();
      const { top: ct, height: ch } = this.containerRef.getBoundingClientRect();
      listColScrollable = (vt + vh <= ct + ch);
    }
    const listColStyles = breakpoint.lessThan.md || !listColScrollable ? {} : {
      height,
      alignContent: 'flex-start',
      overflow: 'auto',
    };
    return (
      <Fragment>
        <div className="col-md-9 border-right">
          <div className="pb-4" ref={elem => this.activeVidContainer = elem}>
            <div className="mb-3">
              <Player
                key={active.vimeoUrl || active.vimeoId}
                video={active.vimeoUrl || active.vimeoId}
                slug={active.slug}
                autoplay={shouldAutoplay}
                onEnd={this.handleVideoEnd}
              />
            </div>
            <h6 className="mb-1">{active.title}</h6>
            <div className="caption mb-3" dangerouslySetInnerHTML={{ __html: active.body }} />
          </div>
        </div>
        <div className="col-md-3 fade-bottom">
          <div className="row" style={listColStyles}>
            {videos.map((item, i) => (
              <div key={i} className="col-6 col-md-12 mb-3">
                {this.renderVideoThumb(item)}
                <h6 className="heading-display mb-1">
                  {isEqual(item, active)
                    ? <span className="theme-blue">{item.title}</span>
                    : <a href={`#${item.vimeoId}`} onClick={e => this.handleVideoClick(e, item)}>{item.title}</a>
                  }
                </h6>
              </div>
            ))}
          </div>
        </div>
      </Fragment>
    );
  }

  render () {
    const { title, body, onCloseClick } = this.props;
    const { active } = this.state;
    return [
      <header key="modal-header" className="modal-header">
        <h2 className="heading-display">{title}</h2>
        <div className="modal-close" onClick={onCloseClick}>
          <FaClose />
        </div>
      </header>,
      <div
        key="modal-content"
        className="modal-content"
        ref={node => this.containerRef = node}
        style={active ? { paddingTop: 0, paddingBottom: 0 } : null}
      >
        <div className="container-fluid" style={{ minWidth: '60vw' }}>
          <div className="row">
            <div className="col-12">
              <div className="body-copy mb-3" dangerouslySetInnerHTML={{ __html: body }} />
            </div>
          </div>
          <div className="row">
            {active ? this.renderActiveVideo() : this.renderVideoList()}
          </div>
        </div>
      </div>,
    ];
  }
}

VideoListLayout.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string,
  videos: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func,
};

VideoListLayout.defaultProps = {
  videos: [],
  onChange: () => {},
};

const mapStateToProps = ({ breakpoint }) => ({ breakpoint });

export default connect(mapStateToProps)(VideoListLayout);



// WEBPACK FOOTER //
// ./src/components/Modal/VideoListLayout.js